import React from "react";
import { Box, Typography } from "@material-ui/core";
import translate from "i18n/translate";
import { SrAlert, SrButton, SrDialog } from "../../../../common";

const Delete = ({ onSubmit, handleClose, data, isSubmitting, error }) => (
  <SrDialog
    handleClose={handleClose}
    heading={translate("common.delete")}
    actions={
      <>
        <SrButton onClick={handleClose} disabled={isSubmitting}>
          {translate("common.cancel")}
        </SrButton>
        <SrButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={() => onSubmit(data.key)}
          disabled={isSubmitting}
        >
          {translate("common.delete")}
        </SrButton>
      </>
    }
  >
    <Typography align="left">
      {translate("applications.deleteApp", {
        delete: data?.application_name,
      })}
    </Typography>
    {error && (
      <Box mt={2}>
        <SrAlert severity="error">{error}</SrAlert>
      </Box>
    )}
  </SrDialog>
);

export default Delete;
